/**
 * Chrome's in-page translation (Google Translate) replaces DOM text nodes with
 * <font> elements. React still holds references to the original text nodes, so
 * a later commit can call removeChild/insertBefore with a node that is no
 * longer a child of the expected parent, crashing the whole app with
 * "NotFoundError: Failed to execute 'removeChild' on 'Node'".
 *
 * Fail soft instead of crashing: log the mismatch and carry on.
 * See https://github.com/facebook/react/issues/11538#issuecomment-417504600
 */
export const installGoogleTranslateDomFix = () => {
    if (typeof Node !== 'function' || !Node.prototype) {
        return;
    }

    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
        if (child.parentNode !== this) {
            console.error('Cannot remove a child from a different parent', child, this);
            return child;
        }

        return originalRemoveChild.call(this, child) as T;
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function <T extends Node>(this: Node, newNode: T, referenceNode: Node | null): T {
        if (referenceNode && referenceNode.parentNode !== this) {
            console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
            return newNode;
        }

        return originalInsertBefore.call(this, newNode, referenceNode) as T;
    };
};
